import React from 'react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  const items = [{
    ch: 'Ch 1',
    desc: 'Debt Snapshot Worksheet — your exact number, one page',
    val: '$15'
  }, {
    ch: 'Ch 2',
    desc: '30-Day Money Map + Ghost Subscription Audit',
    val: '$20'
  }, {
    ch: 'Ch 3',
    desc: 'Budget Reset Template (modified 50/20/30 for real life)',
    val: '$15'
  }, {
    ch: 'Ch 4',
    desc: 'Debt Attack Planner — Snowball, Avalanche & Hybrid',
    val: '$15'
  }, {
    ch: 'Ch 5',
    desc: '3 Negotiation Scripts + ROI Calculator + Call Tracker + Full Rebuttal Library',
    val: '$47',
    highlight: true
  }, {
    ch: 'Ch 6',
    desc: 'Money Finder Checklist + 4 Bill Renegotiation Scripts',
    val: '$35'
  }, {
    ch: 'Ch 7',
    desc: 'Sunday Money Check-In Template (the 15-min ritual)',
    val: '$10'
  }, {
    ch: 'Ch 8',
    desc: '$1,000 Emergency Sprint Tracker',
    val: '$10'
  }, {
    ch: 'Ch 9',
    desc: '3-Account Automation Blueprint',
    val: '$12'
  }, {
    ch: 'Ch 10',
    desc: 'Wealth Starter Kit + Quick Reference Card',
    val: '$10'
  }];
  return <section className="bg-primary-dark py-[100px] px-5" data-id="element-553">
      <div className="max-w-[860px] mx-auto" data-id="element-554">
        <div className="text-center mb-16" data-id="element-555">
          <h2 className="font-serif text-[36px] md:text-[44px] text-cream-light mb-4" data-id="element-556">
            Everything Inside The System
          </h2>
          <p className="font-sans text-[16px] text-cream-light/60" data-id="element-557">
            10 chapters · 19 tools · 7 scripts · One complete transformation
          </p>
        </div>

        <div className="w-full overflow-x-auto mb-10" data-id="element-558">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-559">
            <tbody className="font-sans text-[15px] md:text-[16px]" data-id="element-560">
              {items.map((item, i) => <tr key={i} className="border-b border-gold-accent/10" data-id="element-561">
                  <td className="py-5 pr-4 text-gold-accent font-bold whitespace-nowrap align-top" data-id="element-562">
                    {item.ch}
                  </td>
                  <td className={`py-5 pr-4 ${item.highlight ? 'text-gold-accent font-bold' : 'text-cream-light/80'} align-top`} data-id="element-563">
                    {item.desc}
                  </td>
                  <td className={`py-5 text-right font-mono ${item.highlight ? 'text-gold-accent font-bold' : 'text-gold-accent/80'} align-top`} data-id="element-564">
                    {item.val}
                  </td>
                </tr>)}
              <tr className="border-t-2 border-gold-accent" data-id="element-565">
                <td colSpan={2} className="py-6 text-right pr-6" data-id="element-566">
                  <span className="font-serif text-[24px] md:text-[32px] text-gold-accent" data-id="element-567">
                    TOTAL VALUE: $189
                  </span>
                </td>
                <td className="py-6 text-right" data-id="element-568"></td>
              </tr>
              <tr data-id="element-569">
                <td colSpan={2} className="py-2 text-right pr-6" data-id="element-570">
                  <span className="font-serif text-[32px] md:text-[44px] text-gold-accent font-bold" data-id="element-571">
                    YOUR PRICE: $9.99
                  </span>
                </td>
                <td className="py-2 text-right" data-id="element-572"></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tools & worksheets visual */}
        <div className="my-14 max-w-[680px] mx-auto rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.3)] border border-gold-accent/15" data-id="element-573">
          <img src="https://cdn.magicpatterns.com/uploads/5nvUrMNDMN69B2LBxGjNL4/heylloyd-image-1774831325846.png" alt="The 19 tools inside The Debt-Free System — Debt Payoff Tracker, 50/30/20 Budget Breakdown, Money Finder Checklist" className="w-full h-auto block" data-id="element-574" />
        </div>

        <div className="text-center mt-10" data-id="element-575">
          <p className="font-sans text-[18px] text-cream-light italic leading-relaxed" data-id="element-576">
            $189 in tools and scripts.
            <br data-id="element-577" />
            For less than a DoorDash delivery.
            <br data-id="element-578" />
            Less than the late fee on the bill you forgot this month.
            <br data-id="element-579" />
            Less than one month's interest on a $3,000 balance.
            <br data-id="element-580" />
            <br data-id="element-581" />
            <span className="font-bold text-gold-accent not-italic" data-id="element-582">
              Infinitely less than the $18,500 you'll pay
              <br data-id="element-583" />
              if you keep going without a system.
            </span>
          </p>

          <div className="mt-12" data-id="element-584">
            <CTAButton subText="10 chapters · 19 tools · 7 scripts · Instant download" data-id="element-585">
              GET $189 IN TOOLS FOR $9.99
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}